/**
 * Back to Top Button.
 *
 * @format
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { setProgress } from './animated-link';

export const loadBackToTopButton = (): void => {
  let scrolling = false;

  /**
   * Set Scroll.
   */
  const setScroll = function setScroll(): void {
    scrolling = true;
  };

  /**
   * Top Check.
   */
  const topCheck = (topButton: Element): void => {
    if (window.pageYOffset > 500) {
      topButton.classList.remove('near-top');
    } else {
      topButton.classList.add('near-top');
    }
  };

  /**
   * Back To Top Scroll Check.
   */
  const scrollCheck = (topButton: Element): void => {
    window.addEventListener('scroll', setScroll, false);
    setInterval(() => {
      if (scrolling) {
        topCheck(topButton);
        scrolling = false;
      }
    }, 100);
  };

  /**
   * Back To Top Button.
   */
  const setupBackToTopButton = (): void => {
    const topButton = document.createElement('div');
    const topHeader = document.getElementById('nav-header');
    topButton.innerHTML = `
    <svg
      class="progress-ring"
      width="49"
      height="48">

      <circle
        class="back-to-top"
        stroke="#53565a"
        stroke-width="4"
        fill="transparent"
        r="22"
        cx="24"
        cy="25"
       />
    </svg>`;
    topButton.id = 'back-to-top';
    topButton.classList.add('near-top');
    document.body.appendChild(topButton);

    topButton.addEventListener('click', (event: MouseEvent): void => {
      if (topHeader) {
        event.preventDefault();
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    topButton.addEventListener('mouseenter', (event) => {
      setProgress(100, 'back-to-top');
    });

    topButton.addEventListener('mouseleave', (event) => {
      setProgress(0, 'back-to-top');
    });

    scrollCheck(topButton);
  };
  setupBackToTopButton();
  setProgress(0, 'back-to-top');
};
